import React from "react";

import { WheelPicker } from "@/components/selection/WheelPicker";
import { RegistrationActions } from "@/layouts/RegistrationFlowLayout";
import { getDefaultBirthYearMenuScrollValue } from "@/utilities/options";

type Option = { value: number; label: string };
type AgeStepProps = {
  birthYear: number | "";
  birthMonth: number | "";
  onChangeBirthYear: (value: number) => void;
  onChangeBirthMonth: (value: number) => void;
  yearOptions: Option[];
  monthOptions: Option[];
  isValid: boolean;
  onNext: () => void;
};
const AgeStep: React.FC<AgeStepProps> = ({
  birthYear,
  birthMonth,
  onChangeBirthYear,
  onChangeBirthMonth,
  yearOptions,
  monthOptions,
  isValid,
  onNext,
}) => {
  const today = new Date();
  const age =
    birthYear && birthMonth ? today.getFullYear() - birthYear - (today.getMonth() + 1 < birthMonth ? 1 : 0) : null;
  return (
    <>
      <WheelPicker
        columns={[
          {
            label: "生まれた年",
            values: yearOptions.map((o) => o.value),
            value: birthYear === "" ? null : birthYear,
            initialValue: getDefaultBirthYearMenuScrollValue(),
            unit: "年",
            onChange: onChangeBirthYear,
          },
          {
            label: "生まれた月",
            values: monthOptions.map((o) => o.value),
            value: birthMonth === "" ? null : birthMonth,
            initialValue: 1,
            unit: "月",
            onChange: onChangeBirthMonth,
          },
        ]}
        echo={birthYear && birthMonth ? `${birthYear}年${birthMonth}月 ・ ${age}歳` : undefined}
      />
      <RegistrationActions disabled={!isValid} onNext={onNext} />
    </>
  );
};
export default AgeStep;
